// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see RemotelyClearAppDataPushNotificationReceivedEvent
 */
export var RemotelyClearAppDataPushNotificationReceived = function (_a) {
    var clearTarget = _a.clearTarget, clearTiming = _a.clearTiming;
    return ({
        name: "RemotelyClearAppData PushNotification Received",
        parameters: {
            cdf_entity: "RemotelyClearAppData",
            cdf_action: "PushNotification",
            clear_target: clearTarget !== undefined && clearTarget !== null ? clearTarget.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            clear_timing: clearTiming !== undefined && clearTiming !== null ? clearTiming.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemotelyClearAppDataOperationExecutionStartEvent
 */
export var RemotelyClearAppDataOperationExecutionStart = function (_a) {
    var clearTarget = _a.clearTarget, clearTiming = _a.clearTiming;
    return ({
        name: "RemotelyClearAppData OperationExecution Start",
        parameters: {
            cdf_entity: "RemotelyClearAppData",
            cdf_action: "OperationExecution",
            clear_target: clearTarget !== undefined && clearTarget !== null ? clearTarget.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            clear_timing: clearTiming !== undefined && clearTiming !== null ? clearTiming.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
